import React from 'react';

import { Typography } from '@components/Typography';
import { config } from '@~/config';
import { makeStyles } from '@providers/Theme';

type AppEnvProps = {};

const useStyles = makeStyles((theme) => ({
  root: {
    marginLeft: theme.spacing(1),
  },
}));

export const AppEnv: React.FC<AppEnvProps> = () => {
  const styles = useStyles();

  if (config.appEnv === 'prod') {
    return null;
  }

  return (
    <Typography variant="warning" weight="bold" style={styles.root} size="xl">
      [{config.appEnv}]
    </Typography>
  );
};
